/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingNUXRendererQueryVariables = {
    orgRelayId: string;
    timeZone: string;
    week: unknown;
    myCalendarIds: Array<string>;
};
export type OnboardingNUXRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"OnboardingNUX_viewer">;
    };
};
export type OnboardingNUXRendererQuery = {
    readonly response: OnboardingNUXRendererQueryResponse;
    readonly variables: OnboardingNUXRendererQueryVariables;
};



/*
query OnboardingNUXRendererQuery(
  $orgRelayId: ID!
  $timeZone: String!
  $week: LocalWeek!
  $myCalendarIds: [String!]!
) {
  viewer {
    ...OnboardingNUX_viewer_WUKqv
    id
  }
}

fragment AutopilotFlexibility_event on Event {
  eventParentRelayId
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRowNew_org on Org {
  ...AvatarPerson_org
}

fragment CopyPersonalInviteLinkBtn_org on Org {
  id
  experiments
}

fragment CopyPersonalInviteLinkBtn_user on User {
  id
}

fragment DataSourceCreate_org on Org {
  id
  primaryOrgCalendar
}

fragment DataSource_dataSource on DataSource {
  id
  name
  calendarIds
  syncTargets {
    emailAddress
    calendarId
  }
  state
  type
  username
}

fragment DataSource_org on Org {
  id
  domains
}

fragment DraggableWorkingHours_workingHours on WorkingHours {
  id
  type
  timeZone
  daySettings {
    day
    setting {
      minSlot
      maxSlot
      excludedSlots
    }
  }
  dayOverrides {
    date
    setting {
      minSlot
      maxSlot
      excludedSlots
    }
  }
}

fragment EventSummaryAttendees_attendees on Attendee {
  displayName
  urnValue
  profileId
  urnType
}

fragment EventSummaryAttendees_org on Org {
  id
  domains
}

fragment EventSummaryAutopilotFlex_event on Event {
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryBestTimeRecurrence_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryExternalAttendees_attendees on Attendee {
  displayName
  urnValue
  profileId
  urnType
}

fragment EventSummaryExternalAttendees_org on Org {
  id
  domains
}

fragment EventSummaryRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummaryRoom_attendees on Attendee {
  displayName
  urnValue
}

fragment EventSummaryTime_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}

fragment FastCrawlErrorCard_org on Org {
  id
}

fragment IndividualJtbdSurveyStep_org on Org {
  id
  userSurveyResponseWrapperErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on UserSurveyResponseWrapper {
      id
      userSurveyResponses {
        questionType
        responseType
        questionText
        responseText
        freeformResponse
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment InviteButton_org on Org {
  id
}

fragment InviteCard_org on Org {
  ...InviteButton_org
}

fragment OnboardingAutopilotEvent_event on Event {
  ...EventSummaryRecurrence_event
  ...EventSummaryTime_event
  ...EventSummaryBestTimeRecurrence_event
  ...EventSummaryAutopilotFlex_event
  ...AutopilotFlexibility_event
  isClockwiseEvent
  calendarIds
  eventKey {
    id
    calendarIds
    externalEventId
    hashedCalendars
    orgId
  }
  organizerPerson {
    __typename
    ... on Person {
      isYou
      primaryEmail
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  attendees {
    ...EventSummaryAttendees_attendees
    ...EventSummaryExternalAttendees_attendees
    ...EventSummaryRoom_attendees
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  creator {
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  endTime {
    millis
    timeZone
    offsetMinutes
  }
  organizer {
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  recurringEventId
  recurrenceRules {
    firstInstanceStartTime {
      timeZone
      offsetMinutes
    }
    timeZone
    interval {
      byDay
      count
    }
    cancelledInstances
  }
  startTime {
    millis
    timeZone
    offsetMinutes
  }
  title
  transparency
  isAllDay
  guestsCanInviteOthers
  guestsCanModify
  guestsCanSeeOtherGuests
  locked
  privateCopy
  description
  location
  etag
  htmlLink
  hangoutLink
  annotatedEvent {
    id
    externalEventId
    orgTags {
      tag
      state {
        lastModified
        subjectType
        subjectValue
        active
        value
      }
    }
    userTags {
      tag
      count
      states {
        lastModified
        subjectType
        subjectValue
        active
        value
      }
    }
  }
  createdMillis
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OnboardingAutopilotEvent_org on Org {
  id
  domains
  experiments
  ...EventSummaryAttendees_org
  ...EventSummaryExternalAttendees_org
  ...EventSummaryRecurrence_org
  ...EventSummaryTime_org
  ...AutopilotFlexibility_org
}

fragment OnboardingAutopilotStepRenderer_org_3k5A6X on Org {
  id
  experiments
  primaryOrgCalendar
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      enabledOrganized {
        ...OnboardingAutopilotEvent_event
        calendarIds
        title
        annotatedEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              active
              value
              subjectType
              subjectValue
              lastModified
            }
          }
        }
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        attendees {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
      }
      enabledAttending {
        ...OnboardingAutopilotEvent_event
        calendarIds
        title
        annotatedEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              active
              value
              subjectType
              subjectValue
              lastModified
            }
          }
        }
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
          displayName
        }
        attendees {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
      }
      suggestedOrganized {
        ...OnboardingAutopilotEvent_event
        calendarIds
        title
        annotatedEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              active
              value
              subjectType
              subjectValue
              lastModified
            }
          }
        }
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        attendees {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
      }
      suggestedAttending {
        ...OnboardingAutopilotEvent_event
        title
        calendarIds
        annotatedEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              active
              value
              subjectType
              subjectValue
              lastModified
            }
          }
        }
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        attendees {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  ...OnboardingChromeAutopilot_org_3k5A6X
}

fragment OnboardingAutopilotStepRenderer_user on User {
  id
  emails
}

fragment OnboardingChromeAutopilot_org_3k5A6X on Org {
  ...OnboardingAutopilotEvent_org
  id
  primaryOrgEmail
  focusTimeSavedInHours
  domains
  userDefinedTeam {
    id
    calendarIds
  }
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      enabledOrganized {
        ...OnboardingAutopilotEvent_event
        calendarIds
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
        title
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        attendees {
          urnType
          urnValue
        }
      }
      enabledAttending {
        ...OnboardingAutopilotEvent_event
        calendarIds
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
        title
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
          displayName
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        attendees {
          urnType
          urnValue
        }
      }
      suggestedOrganized {
        ...OnboardingAutopilotEvent_event
        calendarIds
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
        title
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        attendees {
          urnType
          urnValue
        }
      }
      suggestedAttending {
        ...OnboardingAutopilotEvent_event
        calendarIds
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
        title
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        attendees {
          urnType
          urnValue
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment OnboardingChromeIntro_org on Org {
  ...AvatarRowNew_org
  experiments
  name
  focusTimeSavedInHours
  domains
  primaryOrgCalendar
  currentOrgPersons {
    __typename
    ... on OrgPersonList {
      list {
        ...AvatarPerson_orgPerson
        primaryCalendarId
        userId
        personId
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OnboardingChromeIntro_user on User {
  givenName
}

fragment OnboardingColorCodingStep_org_2XYUdJ on Org {
  id
  experiments
  primaryOrgCalendar
  eventColoringSettingsErrorable {
    __typename
    ... on EventColoringSettings {
      eventCategoryColorings {
        active
        eventCategory
        googleColorKey
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  calculateSmartHoldsErrorable(week: $week) {
    __typename
    ... on SmartHoldCalculationResult {
      smartHolds {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
        }
        endTime {
          dateOrDateTime
        }
      }
      events {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
        }
        endTime {
          dateOrDateTime
        }
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
        }
      }
    }
  }
}

fragment OnboardingColorCodingStep_user on User {
  id
  emails
  servicesFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment OnboardingFlexMeetingStepRenderer_org_3k5A6X on Org {
  id
  experiments
  primaryOrgCalendar
  ...OnboardingAutopilotEvent_org
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      suggestedOrganized {
        ...OnboardingAutopilotEvent_event
        calendarIds
        title
        annotatedEvent {
          externalEventId
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        recurringEventId
        recurrenceRules {
          interval {
            interval
            freqType
          }
        }
        annotatedRecurringEvent {
          id
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
          orgTags {
            tag
            state {
              active
              value
              subjectType
              subjectValue
              lastModified
            }
          }
        }
        createdMillis
        eventKey {
          externalEventId
          id
        }
        organizer {
          urnValue
        }
        attendees {
          urnValue
        }
        startTime {
          millis
        }
        endTime {
          millis
        }
        suggestedAutopilotSettingsResponseV3 {
          __typename
          ... on SuggestedAutopilotSettingsResponseV3 {
            intersectionOfAttendeesMeetingHours {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
            calendarIdToMeetingHours {
              calendarId
              dayOffsetTimeSlotRanges {
                minSlot {
                  dayOffset
                  timeSlot
                }
                maxSlot {
                  dayOffset
                  timeSlot
                }
              }
            }
            suggestedAutopilotSettings {
              isRoomFlexible
              movementType
              allowedEndTime {
                dayOffset
                timeSlot
              }
              allowedStartTime {
                dayOffset
                timeSlot
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        moveRangeInLocalTimeV3 {
          __typename
          ... on MoveRangeInLocalTimeV3 {
            allowedStartTimeInclusive {
              dayOffset
              timeSlot
            }
            allowedEndTimeInclusive {
              dayOffset
              timeSlot
            }
          }
          ... on GraphEntityError {
            message
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment OnboardingFlexMeetingStepRenderer_user on User {
  id
  emails
}

fragment OnboardingFocusTimeSyncAndLunchStep_org on Org {
  ...SmartHoldSync_org
  id
  primaryOrgCalendar
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncEnabled
      focusTimeExternalTransparency
      focusTimeIdealMinutesPerWeek
      focusTimeSyncAll
      focusTimeRemindersEnabled
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  eventColoringSettingsErrorable {
    __typename
    ... on EventColoringSettings {
      eventCategoryColorings {
        active
        eventCategory
        googleColorKey
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userMeetingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalWithinDayOptions {
              minTimeSlot
              maxTimeSlot
              minimumDuration
              idealDuration
            }
          }
        }
      }
    }
  }
  calculateSmartHoldsErrorable(week: $week) {
    __typename
    ... on SmartHoldCalculationResult {
      smartHolds {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
      events {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
    }
  }
}

fragment OnboardingFocusTimeSyncAndLunchStep_user on User {
  id
  emails
}

fragment OnboardingFocusTimeSyncStep_org on Org {
  ...SmartHoldSync_org
  id
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncEnabled
      focusTimeSyncAll
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment OnboardingIntroduceAutopilotStep_org on Org {
  experiments
  optimisticSavingsForCurrentUserNextWeekErrorable {
    __typename
    ... on OptimisticSavings {
      couldCalculate
      savingMinutes
    }
  }
}

fragment OnboardingIntroduceFocusTimeStep_org_2XYUdJ on Org {
  primaryOrgCalendar
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  calculateSmartHoldsErrorable(week: $week) {
    __typename
    ... on SmartHoldCalculationResult {
      smartHolds {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
      events {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
    }
  }
}

fragment OnboardingIntroduceFocusTimeStep_user on User {
  id
  emails
}

fragment OnboardingInviteStep_org on Org {
  ...OnboardingOrgInvite_org
  id
  experiments
}

fragment OnboardingInviteStep_viewer on Viewer {
  ...OnboardingOrgInvite_viewer
}

fragment OnboardingLinksStep_org on Org {
  id
  experiments
}

fragment OnboardingLunchStep_org on Org {
  id
  userMeetingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalWithinDayOptions {
              minTimeSlot
              maxTimeSlot
              minimumDuration
              idealDuration
            }
          }
        }
      }
    }
  }
}

fragment OnboardingMeetingHoursStep_org on Org {
  userMeetingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
}

fragment OnboardingNUX_viewer_WUKqv on Viewer {
  ...WebAppNavAvatarMenu_viewer
  ...OnboardingInviteStep_viewer
  ...OnboardingTeamJoinCreateStep_viewer_2rslMm
  outerTeamQueryResultErrorable: teamQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeMyTeams: false) {
    __typename
    ... on TeamQueryResult {
      query
      teams {
        teamId
        id
      }
    }
  }
  user {
    ...OnboardingChromeIntro_user
    ...OnboardingFocusTimeSyncAndLunchStep_user
    ...OnboardingIntroduceFocusTimeStep_user
    ...OnboardingScheduleTestEventStepRenderer_user
    ...OnboardingAutopilotStepRenderer_user
    ...OnboardingColorCodingStep_user
    ...OnboardingPrivateCalendarSyncStep_user
    ...OnboardingSummaryStep_user
    ...OnboardingFlexMeetingStepRenderer_user
    createdTime
    dataSources(first: 1000000) {
      edges {
        node {
          id
          state
          type
          name
        }
      }
    }
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          current {
            id
            state
            percentComplete
            errorMessage
          }
          pending {
            state
            percentComplete
            errorMessage
            id
          }
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          ...FastCrawlErrorCard_org
          ...OnboardingChromeIntro_org
          ...OnboardingSurveyStep_org
          ...IndividualJtbdSurveyStep_org
          ...OnboardingTeamJoinCreateStep_org
          ...OnboardingWorkingHoursStep_org
          ...OnboardingMeetingHoursStep_org
          ...OnboardingLunchStep_org
          ...OnboardingFocusTimeSyncAndLunchStep_org
          ...OnboardingIntroduceAutopilotStep_org
          ...OnboardingLinksStep_org
          ...OnboardingFocusTimeSyncStep_org
          ...OnboardingPrivateCalendarSyncStep_org
          ...OnboardingTravelTimeStep_org
          ...OnboardingSlackStep_org
          ...OnboardingSummaryStep_org
          ...OnboardingIntroduceFocusTimeStep_org_2XYUdJ
          ...OnboardingAutopilotStepRenderer_org_3k5A6X
          ...OnboardingInviteStep_org
          ...OnboardingColorCodingStep_org_2XYUdJ
          ...OnboardingScheduleTestEventStepRenderer_org_2XYUdJ
          ...OnboardingFlexMeetingStepRenderer_org_3k5A6X
          id
          primaryOrgCalendar
          experiments
          crawlTest
          userTeams {
            __typename
            ... on TeamList {
              list {
                teamId
                id
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment OnboardingOrgInvite_org on Org {
  id
  ...InviteCard_org
  ...CopyPersonalInviteLinkBtn_org
  experiments
  personCorpusErrorable {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on PersonList {
      list {
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
        id
      }
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        id
        targetCalendarId
        targetProfile {
          givenName
          familyName
          externalImageUrl
        }
        resolution
        numberOfSharedMeetings
        numberOfOrganizedMeetings
        inviteReason
        totalScore
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        id
        targetCalendarId
        lastSentTime
        targetProfile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
}

fragment OnboardingOrgInvite_viewer on Viewer {
  user {
    ...CopyPersonalInviteLinkBtn_user
    id
  }
  personQueryResultErrorable(query: "", orgRelayId: "") {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on PersonQueryResult {
      query
      persons {
        id
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
      }
    }
  }
}

fragment OnboardingPrivateCalendarSyncStep_org on Org {
  id
  domains
  ...DataSource_org
  ...DataSourceCreate_org
}

fragment OnboardingPrivateCalendarSyncStep_user on User {
  id
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}

fragment OnboardingScheduleTestEventStepRenderer_org_2XYUdJ on Org {
  id
  primaryOrgCalendar
  experiments
  crawlTest
  primaryOrgEmail
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  calculateSmartHoldsErrorable(week: $week) {
    __typename
    ... on SmartHoldCalculationResult {
      events {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
    }
  }
}

fragment OnboardingScheduleTestEventStepRenderer_user on User {
  id
  emails
}

fragment OnboardingSlackStep_org on Org {
  id
  experiments
  slackAccountsErrorable {
    __typename
    ... on SlackAccountList {
      list {
        id
        slackTeamId
        slackUserId
        teamDisplayName
        needsUpdate
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  slackSettingsErrorable {
    __typename
    ... on SlackSettingsList {
      list {
        id
        slackTeamId
        slackUserId
        calendarStatus {
          calendarStatusEnabled
          includeMeetingCategory
          includeMeetingTitle
        }
        dailyDigestSettings {
          enabled
          timeSlot
        }
        dndSettings {
          focusTime
          meeting
        }
        notificationSettings {
          defragSummary
        }
        calendarStatusEnabled
        includeMeetingCategory
        includeMeetingTitle
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OnboardingSummaryStep_org on Org {
  id
  primaryOrgCalendar
  domains
  experiments
  eventColoringSettingsErrorable {
    __typename
    ... on EventColoringSettings {
      eventCategoryColorings {
        active
        eventCategory
        googleColorKey
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        teamId
        id
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
        }
      }
    }
  }
  slackAccountsErrorable {
    __typename
    ... on SlackAccountList {
      list {
        id
        slackTeamId
        slackUserId
        teamDisplayName
        needsUpdate
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  autopilotEventsResponse(timeZone: $timeZone) {
    __typename
    ... on AutopilotEventsResponse {
      enabledOrganized {
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
      }
      enabledAttending {
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
      }
      suggestedOrganized {
        annotatedEvent {
          orgTags {
            tag
            state {
              active
              subjectType
              subjectValue
            }
          }
          userTags {
            tag
            states {
              active
              subjectType
              subjectValue
            }
          }
          id
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment OnboardingSummaryStep_user on User {
  id
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}

fragment OnboardingSurveyStep_org on Org {
  id
  primaryOrgCalendar
  userSurveyResponseWrapperErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on UserSurveyResponseWrapper {
      id
      userSurveyResponses {
        questionType
        responseType
        questionText
        responseText
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment OnboardingTeamJoinCreateStep_org on Org {
  ...TeamJoinCreate_org
  ...AvatarRowNew_org
  id
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamName
        createdBy {
          value
          id
        }
        teamCalendarId
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        userSettings {
          __typename
          ... on TeamUserSettings {
            useTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        invitedMembers {
          addedBy
          person {
            ...AvatarPerson_orgPerson
            primaryCalendarId
            userId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
        teamMembers {
          addedBy
          person {
            ...AvatarPerson_orgPerson
            primaryCalendarId
            userId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
      }
    }
  }
}

fragment OnboardingTeamJoinCreateStep_viewer_2rslMm on Viewer {
  ...TeamJoinCreate_viewer_2rslMm
  user {
    id
  }
  id
}

fragment OnboardingTravelTimeStep_org on Org {
  ...WorkAddress_org
  workAddressForUser {
    __typename
    ... on Address {
      rawAddress
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  id
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalWithinDayOptions {
              minTimeSlot
              maxTimeSlot
              minimumDuration
              idealDuration
            }
          }
        }
      }
    }
  }
}

fragment OnboardingWorkingHoursStep_org on Org {
  experiments
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      ...DraggableWorkingHours_workingHours
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userMeetingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      ...DraggableWorkingHours_workingHours
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
}

fragment SmartHoldSync_org on Org {
  id
  primaryOrgCalendar
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncEnabled
      lunchSyncEnabled
      travelTimeSyncEnabled
      focusTimeExternalTransparency
      focusTimeIdealMinutesPerWeek
      focusTimeSyncAll
      focusTimeRemindersEnabled
      lunchRemindersEnabled
      travelTimeRemindersEnabled
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  focusTimeStats {
    __typename
    ... on FocusTimeStats {
      minutesPerWeek
    }
  }
}

fragment TeamJoinCreate_org on Org {
  ...AvatarRowNew_org
  ...TeamSettingsSearch_org
  ...TeamSearchInputRenderer_org
  id
  primaryOrgCalendar
  orgPersonForUserErrorable {
    __typename
    ... on OrgPerson {
      personId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        syncSources {
          type
          value
          id
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamName
        createdBy {
          value
          id
        }
        teamCalendarId
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        userSettings {
          __typename
          ... on TeamUserSettings {
            useTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        teamMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
        invitedMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
      }
    }
  }
  suggestedTeams {
    __typename
    ... on SuggestedTeamList {
      list {
        team {
          id
          teamId
          teamName
          createdBy {
            value
            id
          }
          teamMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
          invitedMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
        }
        reasons {
          type
          value
        }
        score
      }
    }
  }
}

fragment TeamJoinCreate_viewer_2rslMm on Viewer {
  ...TeamSettingsSearch_viewer_YNSM7
  user {
    id
  }
  id
  teamQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeMyTeams: true) {
    __typename
    ... on TeamQueryResult {
      query
      teams {
        teamName
        teamId
        teamRoleAndPersonIds {
          role
          personId
        }
        id
      }
      teamMembers {
        role
        person {
          ...AvatarPerson_orgPerson
          personId
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
          }
          id
        }
      }
    }
  }
}

fragment TeamSearchInputRenderer_org on Org {
  id
}

fragment TeamSettingsSearch_org on Org {
  ...TeamSettingsTeammate_org
  id
  primaryOrgCalendar
  workingGroups(first: 1000000) {
    edges {
      node {
        calendarIds
        id
      }
    }
  }
}

fragment TeamSettingsSearch_viewer_YNSM7 on Viewer {
  orgPersonQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on OrgPersonQueryResult {
      query
      persons {
        ...AvatarPerson_orgPerson
        userId
        personId
        primaryCalendarId
        calendarAliases
        redirectPersonId
        isYou
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}

fragment TeamSettingsTeammate_org on Org {
  ...AvatarPerson_org
  id
  primaryOrgEmail
}

fragment WebAppNavAvatarMenu_viewer on Viewer {
  id
  user {
    givenName
    familyName
    externalImageUrl
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          previousState
          current {
            id
            state
            percentComplete
            errorMessage
          }
          pending {
            id
            state
            percentComplete
            errorMessage
          }
        }
      }
    }
    dataSources(first: 1000000) {
      edges {
        node {
          id
          status
          name
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          primaryOrgCalendar
          domains
          slackAccountsErrorable {
            __typename
            ... on SlackAccountList {
              list {
                id
                slackTeamId
                slackUserId
                teamDisplayName
              }
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          eventColoringSettingsErrorable {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on EventColoringSettings {
              eventCategoryColorings {
                googleColorKey
                eventCategory
                active
                isUserSet
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          userPerson {
            __typename
            ... on Person {
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
        }
      }
    }
    id
  }
}

fragment WorkAddress_org on Org {
  id
  workAddressForUser {
    __typename
    ... on Address {
      rawAddress
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "myCalendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "week"
    } as any, v4 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v5 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v6 = {
        "kind": "Variable",
        "name": "week",
        "variableName": "week"
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalImageUrl",
        "storageKey": null
    } as any, v11 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
    } as any, v13 = [
        (v7 /*: any*/),
        (v12 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackTeamId",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackUserId",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v23 = {
        "kind": "InlineFragment",
        "selections": [
            (v21 /*: any*/),
            (v22 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v24 = {
        "kind": "InlineFragment",
        "selections": [
            (v22 /*: any*/),
            (v21 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v26 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v27 = [
        (v8 /*: any*/),
        (v9 /*: any*/),
        (v10 /*: any*/)
    ], v28 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": (v27 /*: any*/),
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v33 = [
        (v18 /*: any*/),
        (v7 /*: any*/),
        (v29 /*: any*/),
        (v30 /*: any*/),
        (v31 /*: any*/),
        (v28 /*: any*/),
        (v32 /*: any*/)
    ], v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v36 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            (v36 /*: any*/),
            (v7 /*: any*/)
        ],
        "storageKey": null
    } as any, v38 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgPerson",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": (v33 /*: any*/),
        "storageKey": null
    } as any, v39 = [
        (v38 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addedBy",
            "storageKey": null
        } as any
    ], v40 = [
        (v38 /*: any*/)
    ], v41 = [
        {
            "kind": "Literal",
            "name": "resolveOverrides",
            "value": false
        } as any
    ], v42 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v43 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v44 = [
        (v7 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasBeenSet",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "WorkingHours",
            "kind": "LinkedField",
            "name": "workingHours",
            "plural": false,
            "selections": [
                (v7 /*: any*/),
                (v15 /*: any*/),
                (v42 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DaySetting",
                    "kind": "LinkedField",
                    "name": "daySettings",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "day",
                            "storageKey": null
                        },
                        (v43 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DayOverride",
                    "kind": "LinkedField",
                    "name": "dayOverrides",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                        },
                        (v43 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v45 = [
        (v7 /*: any*/),
        (v15 /*: any*/),
        (v36 /*: any*/)
    ], v46 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v47 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
    } as any, v48 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClockwiseEvent",
        "storageKey": null
    } as any, v49 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
    } as any, v50 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v51 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseStatus",
        "storageKey": null
    } as any, v52 = [
        (v50 /*: any*/),
        (v51 /*: any*/)
    ], v53 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v54 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v55 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v56 = [
        (v54 /*: any*/),
        (v55 /*: any*/),
        (v36 /*: any*/)
    ], v57 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v58 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
    } as any, v59 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v60 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v61 = [
        (v59 /*: any*/),
        (v60 /*: any*/)
    ], v62 = [
        (v46 /*: any*/),
        (v47 /*: any*/),
        (v48 /*: any*/),
        (v49 /*: any*/),
        (v16 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "Attendee",
            "kind": "LinkedField",
            "name": "organizer",
            "plural": false,
            "selections": (v52 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "Attendee",
            "kind": "LinkedField",
            "name": "attendees",
            "plural": true,
            "selections": (v52 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "Attendee",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
                (v50 /*: any*/)
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "AnnotatedEvent",
            "kind": "LinkedField",
            "name": "annotatedEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTag",
                    "kind": "LinkedField",
                    "name": "userTags",
                    "plural": true,
                    "selections": [
                        (v53 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "states",
                            "plural": true,
                            "selections": (v56 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrgTag",
                    "kind": "LinkedField",
                    "name": "orgTags",
                    "plural": true,
                    "selections": [
                        (v53 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v56 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                (v7 /*: any*/)
            ],
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "EventKey",
            "kind": "LinkedField",
            "name": "eventKey",
            "plural": false,
            "selections": [
                (v57 /*: any*/),
                (v7 /*: any*/)
            ],
            "storageKey": null
        } as any,
        (v58 /*: any*/),
        {
            "alias": null,
            "args": null,
            "concreteType": "EventTime",
            "kind": "LinkedField",
            "name": "startTime",
            "plural": false,
            "selections": (v61 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "EventTime",
            "kind": "LinkedField",
            "name": "endTime",
            "plural": false,
            "selections": (v61 /*: any*/),
            "storageKey": null
        } as any
    ], v63 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarStatusEnabled",
        "storageKey": null
    } as any, v64 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingCategory",
        "storageKey": null
    } as any, v65 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingTitle",
        "storageKey": null
    } as any, v66 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeSlot",
        "storageKey": null
    } as any, v67 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastModified",
        "storageKey": null
    } as any, v68 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
    } as any, v69 = [
        (v15 /*: any*/),
        (v59 /*: any*/),
        (v42 /*: any*/),
        (v60 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v70 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "startTime",
        "plural": false,
        "selections": (v69 /*: any*/),
        "storageKey": null
    } as any, v71 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v69 /*: any*/),
        "storageKey": null
    } as any, v72 = {
        "alias": null,
        "args": null,
        "concreteType": "EventKey",
        "kind": "LinkedField",
        "name": "eventKey",
        "plural": false,
        "selections": [
            (v57 /*: any*/),
            (v7 /*: any*/),
            (v16 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hashedCalendars",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orgId",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v73 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventFlexibilityErrorable",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventFlexibilityNew",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flex",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flexString",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "EventFlexibilityNewList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v74 = {
        "alias": null,
        "args": null,
        "concreteType": "RecurrenceRules",
        "kind": "LinkedField",
        "name": "recurrenceRules",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "firstInstanceStartTime",
                "plural": false,
                "selections": (v69 /*: any*/),
                "storageKey": null
            },
            (v42 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "IntervalDefinition",
                "kind": "LinkedField",
                "name": "interval",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "interval",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bySetPos",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "freqType",
                        "storageKey": null
                    },
                    (v68 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "untilTime",
                        "plural": false,
                        "selections": (v69 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancelledInstances",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v75 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgTag",
        "kind": "LinkedField",
        "name": "orgTags",
        "plural": true,
        "selections": [
            (v53 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                    (v25 /*: any*/),
                    (v36 /*: any*/),
                    (v54 /*: any*/),
                    (v55 /*: any*/),
                    (v67 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v76 = {
        "alias": null,
        "args": null,
        "concreteType": "AnnotatedEvent",
        "kind": "LinkedField",
        "name": "annotatedRecurringEvent",
        "plural": false,
        "selections": [
            (v75 /*: any*/),
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "UserTag",
                "kind": "LinkedField",
                "name": "userTags",
                "plural": true,
                "selections": [
                    (v53 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagState",
                        "kind": "LinkedField",
                        "name": "states",
                        "plural": true,
                        "selections": [
                            (v36 /*: any*/),
                            (v54 /*: any*/),
                            (v55 /*: any*/),
                            (v67 /*: any*/),
                            (v25 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v77 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventParentRelayId",
        "storageKey": null
    } as any, v78 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v79 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v80 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "attendeePeople",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            (v7 /*: any*/),
                            (v78 /*: any*/),
                            (v79 /*: any*/),
                            (v28 /*: any*/),
                            (v30 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "type": "PersonList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v81 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        (v66 /*: any*/)
    ], v82 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v81 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v81 /*: any*/),
            "storageKey": null
        } as any
    ], v83 = {
        "kind": "InlineFragment",
        "selections": [
            (v21 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v84 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "suggestedAutopilotSettingsResponseV3",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlotRange",
                        "kind": "LinkedField",
                        "name": "intersectionOfAttendeesMeetingHours",
                        "plural": false,
                        "selections": (v82 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                        "kind": "LinkedField",
                        "name": "calendarIdToMeetingHours",
                        "plural": true,
                        "selections": [
                            (v17 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlotRange",
                                "kind": "LinkedField",
                                "name": "dayOffsetTimeSlotRanges",
                                "plural": true,
                                "selections": (v82 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutopilotSettingsV3",
                        "kind": "LinkedField",
                        "name": "suggestedAutopilotSettings",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRoomFlexible",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "movementType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedEndTime",
                                "plural": false,
                                "selections": (v81 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedStartTime",
                                "plural": false,
                                "selections": (v81 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SuggestedAutopilotSettingsResponseV3",
                "abstractKey": null
            },
            (v83 /*: any*/)
        ],
        "storageKey": null
    } as any, v85 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "moveRangeInLocalTimeV3",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlot",
                        "kind": "LinkedField",
                        "name": "allowedStartTimeInclusive",
                        "plural": false,
                        "selections": (v81 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlot",
                        "kind": "LinkedField",
                        "name": "allowedEndTimeInclusive",
                        "plural": false,
                        "selections": (v81 /*: any*/),
                        "storageKey": null
                    }
                ],
                "type": "MoveRangeInLocalTimeV3",
                "abstractKey": null
            },
            (v83 /*: any*/)
        ],
        "storageKey": null
    } as any, v86 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "organizerPerson",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    (v30 /*: any*/),
                    (v79 /*: any*/)
                ],
                "type": "Person",
                "abstractKey": null
            },
            (v26 /*: any*/)
        ],
        "storageKey": null
    } as any, v87 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v88 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileId",
        "storageKey": null
    } as any, v89 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnType",
        "storageKey": null
    } as any, v90 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optional",
        "storageKey": null
    } as any, v91 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizer",
        "storageKey": null
    } as any, v92 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resource",
        "storageKey": null
    } as any, v93 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "attendees",
        "plural": true,
        "selections": [
            (v87 /*: any*/),
            (v50 /*: any*/),
            (v88 /*: any*/),
            (v89 /*: any*/),
            (v90 /*: any*/),
            (v91 /*: any*/),
            (v92 /*: any*/),
            (v51 /*: any*/)
        ],
        "storageKey": null
    } as any, v94 = [
        (v87 /*: any*/),
        (v88 /*: any*/),
        (v90 /*: any*/),
        (v91 /*: any*/),
        (v92 /*: any*/),
        (v51 /*: any*/),
        (v89 /*: any*/),
        (v50 /*: any*/)
    ], v95 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": (v94 /*: any*/),
        "storageKey": null
    } as any, v96 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": (v94 /*: any*/),
        "storageKey": null
    } as any, v97 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recurringEventId",
        "storageKey": null
    } as any, v98 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transparency",
        "storageKey": null
    } as any, v99 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "guestsCanInviteOthers",
        "storageKey": null
    } as any, v100 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "guestsCanModify",
        "storageKey": null
    } as any, v101 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "guestsCanSeeOtherGuests",
        "storageKey": null
    } as any, v102 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "privateCopy",
        "storageKey": null
    } as any, v103 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v104 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "etag",
        "storageKey": null
    } as any, v105 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "htmlLink",
        "storageKey": null
    } as any, v106 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hangoutLink",
        "storageKey": null
    } as any, v107 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdMillis",
        "storageKey": null
    } as any, v108 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "featureStatesForOrganizer",
        "plural": false,
        "selections": [
            (v18 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "MixedFreemiumOrgUiState",
                        "kind": "LinkedField",
                        "name": "mixedFreemiumOrgUIState",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "autopilotPaused",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "moveRangesEnabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "FeatureStates",
                "abstractKey": null
            },
            (v24 /*: any*/)
        ],
        "storageKey": null
    } as any, v109 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "AnnotatedEvent",
            "kind": "LinkedField",
            "name": "annotatedEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrgTag",
                    "kind": "LinkedField",
                    "name": "orgTags",
                    "plural": true,
                    "selections": [
                        (v53 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                                (v25 /*: any*/),
                                (v54 /*: any*/),
                                (v55 /*: any*/),
                                (v36 /*: any*/),
                                (v67 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTag",
                    "kind": "LinkedField",
                    "name": "userTags",
                    "plural": true,
                    "selections": [
                        (v53 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TagState",
                            "kind": "LinkedField",
                            "name": "states",
                            "plural": true,
                            "selections": [
                                (v25 /*: any*/),
                                (v54 /*: any*/),
                                (v55 /*: any*/),
                                (v67 /*: any*/),
                                (v36 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v68 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v7 /*: any*/),
                (v57 /*: any*/)
            ],
            "storageKey": null
        } as any,
        (v49 /*: any*/),
        (v70 /*: any*/),
        (v71 /*: any*/),
        (v72 /*: any*/),
        (v73 /*: any*/),
        (v74 /*: any*/),
        (v76 /*: any*/),
        (v77 /*: any*/),
        (v80 /*: any*/),
        (v84 /*: any*/),
        (v85 /*: any*/),
        (v48 /*: any*/),
        (v16 /*: any*/),
        (v86 /*: any*/),
        (v93 /*: any*/),
        (v95 /*: any*/),
        (v96 /*: any*/),
        (v97 /*: any*/),
        (v46 /*: any*/),
        (v98 /*: any*/),
        (v99 /*: any*/),
        (v100 /*: any*/),
        (v101 /*: any*/),
        (v47 /*: any*/),
        (v102 /*: any*/),
        (v103 /*: any*/),
        (v58 /*: any*/),
        (v104 /*: any*/),
        (v105 /*: any*/),
        (v106 /*: any*/),
        (v107 /*: any*/),
        (v108 /*: any*/)
    ], v110 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUser",
        "storageKey": null
    } as any, v111 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetCalendarId",
        "storageKey": null
    } as any, v112 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "targetProfile",
        "plural": false,
        "selections": (v27 /*: any*/),
        "storageKey": null
    } as any, v113 = {
        "kind": "Literal",
        "name": "query",
        "value": ""
    } as any, v114 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
    } as any, v115 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingNUXRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "myCalendarIds",
                                    "variableName": "myCalendarIds"
                                },
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "OnboardingNUX_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "OnboardingNUXRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v7 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "flowKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "previousState",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "current",
                                                            "plural": false,
                                                            "selections": (v13 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "pending",
                                                            "plural": false,
                                                            "selections": (v13 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "status",
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v15 /*: any*/),
                                                        (v16 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v11 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackAccountsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackAccount",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamDisplayName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "needsUpdate",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackAccountList",
                                                                    "abstractKey": null
                                                                },
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v24 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v25 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userPerson",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v28 /*: any*/)
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "focusTimeSavedInHours",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "currentOrgPersons",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": (v33 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonList",
                                                                    "abstractKey": null
                                                                },
                                                                (v24 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userSurveyResponseWrapperErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v24 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserSurveyResponse",
                                                                            "kind": "LinkedField",
                                                                            "name": "userSurveyResponses",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "questionType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "responseType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "questionText",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "responseText",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "freeformResponse",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "UserSurveyResponseWrapper",
                                                                    "abstractKey": null
                                                                },
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v11 /*: any*/),
                                                            "concreteType": "WorkingGroupConnection",
                                                            "kind": "LinkedField",
                                                            "name": "workingGroups",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingGroupEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "WorkingGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v16 /*: any*/),
                                                                                (v7 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "workingGroups(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "orgPersonForUserErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v32 /*: any*/)
                                                                    ],
                                                                    "type": "OrgPerson",
                                                                    "abstractKey": null
                                                                },
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v34 /*: any*/),
                                                                        (v35 /*: any*/)
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v24 /*: any*/),
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "billingGroups",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "BillingGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v14 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "syncSources",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        (v36 /*: any*/),
                                                                                        (v7 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "subscription",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v18 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "PaymentSubscription",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "subscription",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v7 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "productType",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SubscriptionDetails",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v23 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroupList",
                                                                    "abstractKey": null
                                                                },
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Team",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v34 /*: any*/),
                                                                                (v35 /*: any*/),
                                                                                (v37 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamCalendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "settings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v18 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "manageTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v26 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v18 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "useTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamUserSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v26 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TeamMember",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "teamMembers",
                                                                                    "plural": true,
                                                                                    "selections": (v39 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TeamMember",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "invitedMembers",
                                                                                    "plural": true,
                                                                                    "selections": (v39 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "suggestedTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedTeam",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Team",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "team",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v7 /*: any*/),
                                                                                        (v34 /*: any*/),
                                                                                        (v35 /*: any*/),
                                                                                        (v37 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TeamMember",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "teamMembers",
                                                                                            "plural": true,
                                                                                            "selections": (v40 /*: any*/),
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TeamMember",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "invitedMembers",
                                                                                            "plural": true,
                                                                                            "selections": (v40 /*: any*/),
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SuggestedTeamReason",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reasons",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        (v36 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "score",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SuggestedTeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v41 /*: any*/),
                                                            "concreteType": "UserWorkingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userWorkingHours",
                                                            "plural": false,
                                                            "selections": (v44 /*: any*/),
                                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v41 /*: any*/),
                                                            "concreteType": "UserMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userMeetingHours",
                                                            "plural": false,
                                                            "selections": (v44 /*: any*/),
                                                            "storageKey": "userMeetingHours(resolveOverrides:false)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v11 /*: any*/),
                                                            "concreteType": "GoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "userGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "GoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Goal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "goalId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "targetUrn",
                                                                                    "plural": false,
                                                                                    "selections": (v45 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "otherUrns",
                                                                                    "plural": true,
                                                                                    "selections": (v45 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v14 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "valueUrn",
                                                                                    "plural": false,
                                                                                    "selections": (v45 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isDeleted",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "GoalOptions",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "syncToGoogle",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "specificOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v18 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "minTimeSlot",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "maxTimeSlot",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "minimumDuration",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "idealDuration",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "GoalWithinDayOptions",
                                                                                                    "abstractKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "userGoals(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "shadowCalendarSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "lunchSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "travelTimeSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeExternalTransparency",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeIdealMinutesPerWeek",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncAll",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeRemindersEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "lunchRemindersEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "travelTimeRemindersEnabled",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ShadowCalendarSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "focusTimeStats",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "minutesPerWeek",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FocusTimeStats",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v6 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "calculateSmartHoldsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "smartHolds",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "events",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SmartHoldCalculationResult",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "optimisticSavingsForCurrentUserNextWeekErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "couldCalculate",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "savingMinutes",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OptimisticSavings",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "workAddressForUser",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "rawAddress",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Address",
                                                                    "abstractKey": null
                                                                },
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v20 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackCalendarStatusSync",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "calendarStatus",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v63 /*: any*/),
                                                                                        (v64 /*: any*/),
                                                                                        (v65 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDailyDigestSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dailyDigestSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "enabled",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v66 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackDndSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "dndSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "focusTime",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "meeting",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SlackNotificationSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "notificationSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defragSummary",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v63 /*: any*/),
                                                                                (v64 /*: any*/),
                                                                                (v65 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackSettingsList",
                                                                    "abstractKey": null
                                                                },
                                                                (v24 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v5 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "autopilotEventsResponse",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "enabledOrganized",
                                                                            "plural": true,
                                                                            "selections": (v109 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "enabledAttending",
                                                                            "plural": true,
                                                                            "selections": (v109 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedOrganized",
                                                                            "plural": true,
                                                                            "selections": (v109 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "suggestedAttending",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v49 /*: any*/),
                                                                                (v70 /*: any*/),
                                                                                (v71 /*: any*/),
                                                                                (v72 /*: any*/),
                                                                                (v73 /*: any*/),
                                                                                (v74 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AnnotatedEvent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "annotatedEvent",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v75 /*: any*/),
                                                                                        (v7 /*: any*/),
                                                                                        (v57 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "UserTag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "userTags",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v53 /*: any*/),
                                                                                                (v68 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TagState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "states",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        (v67 /*: any*/),
                                                                                                        (v54 /*: any*/),
                                                                                                        (v55 /*: any*/),
                                                                                                        (v25 /*: any*/),
                                                                                                        (v36 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v76 /*: any*/),
                                                                                (v77 /*: any*/),
                                                                                (v80 /*: any*/),
                                                                                (v84 /*: any*/),
                                                                                (v85 /*: any*/),
                                                                                (v48 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v86 /*: any*/),
                                                                                (v93 /*: any*/),
                                                                                (v95 /*: any*/),
                                                                                (v96 /*: any*/),
                                                                                (v97 /*: any*/),
                                                                                (v46 /*: any*/),
                                                                                (v98 /*: any*/),
                                                                                (v99 /*: any*/),
                                                                                (v100 /*: any*/),
                                                                                (v101 /*: any*/),
                                                                                (v47 /*: any*/),
                                                                                (v102 /*: any*/),
                                                                                (v103 /*: any*/),
                                                                                (v58 /*: any*/),
                                                                                (v104 /*: any*/),
                                                                                (v105 /*: any*/),
                                                                                (v106 /*: any*/),
                                                                                (v107 /*: any*/),
                                                                                (v108 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "AutopilotEventsResponse",
                                                                    "abstractKey": null
                                                                },
                                                                (v83 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "UserDefinedTeam",
                                                            "kind": "LinkedField",
                                                            "name": "userDefinedTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personCorpusErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v18 /*: any*/),
                                                                (v83 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v79 /*: any*/),
                                                                                (v78 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v30 /*: any*/),
                                                                                (v110 /*: any*/),
                                                                                (v7 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v11 /*: any*/),
                                                            "concreteType": "SuggestedOrgInviteConnection",
                                                            "kind": "LinkedField",
                                                            "name": "suggestedInvites",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SuggestedOrgInviteEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedOrgInvite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v111 /*: any*/),
                                                                                (v112 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "resolution",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "numberOfSharedMeetings",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "numberOfOrganizedMeetings",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "inviteReason",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "totalScore",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "suggestedInvites(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v11 /*: any*/),
                                                            "concreteType": "OrgInviteConnection",
                                                            "kind": "LinkedField",
                                                            "name": "pendingInvites",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "OrgInviteEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgInvite",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v7 /*: any*/),
                                                                                (v111 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "lastSentTime",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v112 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "pendingInvites(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "crawlTest",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v7 /*: any*/),
                                (v78 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "servicesFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v18 /*: any*/),
                                        (v24 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        (v26 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdTime",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orgRelayId",
                                    "value": ""
                                },
                                (v113 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "personQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                (v24 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v114 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v79 /*: any*/),
                                                (v78 /*: any*/),
                                                (v28 /*: any*/),
                                                (v30 /*: any*/),
                                                (v110 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "PersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": "personQueryResultErrorable(orgRelayId:\"\",query:\"\")"
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "excludeCalendars",
                                    "variableName": "myCalendarIds"
                                },
                                (v4 /*: any*/),
                                (v113 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "orgPersonQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                (v24 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v114 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v18 /*: any*/),
                                                (v7 /*: any*/),
                                                (v29 /*: any*/),
                                                (v30 /*: any*/),
                                                (v31 /*: any*/),
                                                (v28 /*: any*/),
                                                (v32 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "calendarAliases",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "redirectPersonId",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "OrgPersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "excludeMyTeams",
                                    "value": true
                                },
                                (v4 /*: any*/),
                                (v113 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "teamQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v114 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "teams",
                                            "plural": true,
                                            "selections": [
                                                (v35 /*: any*/),
                                                (v34 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TeamRoleAndPersonId",
                                                    "kind": "LinkedField",
                                                    "name": "teamRoleAndPersonIds",
                                                    "plural": true,
                                                    "selections": [
                                                        (v115 /*: any*/),
                                                        (v32 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TeamMember",
                                            "kind": "LinkedField",
                                            "name": "teamMembers",
                                            "plural": true,
                                            "selections": [
                                                (v115 /*: any*/),
                                                (v38 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "TeamQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": "outerTeamQueryResultErrorable",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "excludeMyTeams",
                                    "value": false
                                },
                                (v4 /*: any*/),
                                (v113 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "teamQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v18 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v114 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "teams",
                                            "plural": true,
                                            "selections": [
                                                (v34 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "TeamQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8c0fd28bfa0ff6135f1bb6dc0446646e",
            "id": null,
            "metadata": {},
            "name": "OnboardingNUXRendererQuery",
            "operationKind": "query",
            "text": "query OnboardingNUXRendererQuery(\n  $orgRelayId: ID!\n  $timeZone: String!\n  $week: LocalWeek!\n  $myCalendarIds: [String!]!\n) {\n  viewer {\n    ...OnboardingNUX_viewer_WUKqv\n    id\n  }\n}\n\nfragment AutopilotFlexibility_event on Event {\n  eventParentRelayId\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRowNew_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment CopyPersonalInviteLinkBtn_org on Org {\n  id\n  experiments\n}\n\nfragment CopyPersonalInviteLinkBtn_user on User {\n  id\n}\n\nfragment DataSourceCreate_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment DataSource_dataSource on DataSource {\n  id\n  name\n  calendarIds\n  syncTargets {\n    emailAddress\n    calendarId\n  }\n  state\n  type\n  username\n}\n\nfragment DataSource_org on Org {\n  id\n  domains\n}\n\nfragment DraggableWorkingHours_workingHours on WorkingHours {\n  id\n  type\n  timeZone\n  daySettings {\n    day\n    setting {\n      minSlot\n      maxSlot\n      excludedSlots\n    }\n  }\n  dayOverrides {\n    date\n    setting {\n      minSlot\n      maxSlot\n      excludedSlots\n    }\n  }\n}\n\nfragment EventSummaryAttendees_attendees on Attendee {\n  displayName\n  urnValue\n  profileId\n  urnType\n}\n\nfragment EventSummaryAttendees_org on Org {\n  id\n  domains\n}\n\nfragment EventSummaryAutopilotFlex_event on Event {\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryBestTimeRecurrence_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryExternalAttendees_attendees on Attendee {\n  displayName\n  urnValue\n  profileId\n  urnType\n}\n\nfragment EventSummaryExternalAttendees_org on Org {\n  id\n  domains\n}\n\nfragment EventSummaryRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummaryRoom_attendees on Attendee {\n  displayName\n  urnValue\n}\n\nfragment EventSummaryTime_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment FastCrawlErrorCard_org on Org {\n  id\n}\n\nfragment IndividualJtbdSurveyStep_org on Org {\n  id\n  userSurveyResponseWrapperErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on UserSurveyResponseWrapper {\n      id\n      userSurveyResponses {\n        questionType\n        responseType\n        questionText\n        responseText\n        freeformResponse\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment InviteButton_org on Org {\n  id\n}\n\nfragment InviteCard_org on Org {\n  ...InviteButton_org\n}\n\nfragment OnboardingAutopilotEvent_event on Event {\n  ...EventSummaryRecurrence_event\n  ...EventSummaryTime_event\n  ...EventSummaryBestTimeRecurrence_event\n  ...EventSummaryAutopilotFlex_event\n  ...AutopilotFlexibility_event\n  isClockwiseEvent\n  calendarIds\n  eventKey {\n    id\n    calendarIds\n    externalEventId\n    hashedCalendars\n    orgId\n  }\n  organizerPerson {\n    __typename\n    ... on Person {\n      isYou\n      primaryEmail\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  attendees {\n    ...EventSummaryAttendees_attendees\n    ...EventSummaryExternalAttendees_attendees\n    ...EventSummaryRoom_attendees\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  creator {\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  endTime {\n    millis\n    timeZone\n    offsetMinutes\n  }\n  organizer {\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  recurringEventId\n  recurrenceRules {\n    firstInstanceStartTime {\n      timeZone\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      byDay\n      count\n    }\n    cancelledInstances\n  }\n  startTime {\n    millis\n    timeZone\n    offsetMinutes\n  }\n  title\n  transparency\n  isAllDay\n  guestsCanInviteOthers\n  guestsCanModify\n  guestsCanSeeOtherGuests\n  locked\n  privateCopy\n  description\n  location\n  etag\n  htmlLink\n  hangoutLink\n  annotatedEvent {\n    id\n    externalEventId\n    orgTags {\n      tag\n      state {\n        lastModified\n        subjectType\n        subjectValue\n        active\n        value\n      }\n    }\n    userTags {\n      tag\n      count\n      states {\n        lastModified\n        subjectType\n        subjectValue\n        active\n        value\n      }\n    }\n  }\n  createdMillis\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OnboardingAutopilotEvent_org on Org {\n  id\n  domains\n  experiments\n  ...EventSummaryAttendees_org\n  ...EventSummaryExternalAttendees_org\n  ...EventSummaryRecurrence_org\n  ...EventSummaryTime_org\n  ...AutopilotFlexibility_org\n}\n\nfragment OnboardingAutopilotStepRenderer_org_3k5A6X on Org {\n  id\n  experiments\n  primaryOrgCalendar\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      enabledOrganized {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        title\n        annotatedEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n              subjectValue\n              lastModified\n            }\n          }\n        }\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        attendees {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n      }\n      enabledAttending {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        title\n        annotatedEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n              subjectValue\n              lastModified\n            }\n          }\n        }\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n          displayName\n        }\n        attendees {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n      }\n      suggestedOrganized {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        title\n        annotatedEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n              subjectValue\n              lastModified\n            }\n          }\n        }\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        attendees {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n      }\n      suggestedAttending {\n        ...OnboardingAutopilotEvent_event\n        title\n        calendarIds\n        annotatedEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n              subjectValue\n              lastModified\n            }\n          }\n        }\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        attendees {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  ...OnboardingChromeAutopilot_org_3k5A6X\n}\n\nfragment OnboardingAutopilotStepRenderer_user on User {\n  id\n  emails\n}\n\nfragment OnboardingChromeAutopilot_org_3k5A6X on Org {\n  ...OnboardingAutopilotEvent_org\n  id\n  primaryOrgEmail\n  focusTimeSavedInHours\n  domains\n  userDefinedTeam {\n    id\n    calendarIds\n  }\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      enabledOrganized {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        attendees {\n          urnType\n          urnValue\n        }\n      }\n      enabledAttending {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n          displayName\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        attendees {\n          urnType\n          urnValue\n        }\n      }\n      suggestedOrganized {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        attendees {\n          urnType\n          urnValue\n        }\n      }\n      suggestedAttending {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n        title\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        attendees {\n          urnType\n          urnValue\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment OnboardingChromeIntro_org on Org {\n  ...AvatarRowNew_org\n  experiments\n  name\n  focusTimeSavedInHours\n  domains\n  primaryOrgCalendar\n  currentOrgPersons {\n    __typename\n    ... on OrgPersonList {\n      list {\n        ...AvatarPerson_orgPerson\n        primaryCalendarId\n        userId\n        personId\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OnboardingChromeIntro_user on User {\n  givenName\n}\n\nfragment OnboardingColorCodingStep_org_2XYUdJ on Org {\n  id\n  experiments\n  primaryOrgCalendar\n  eventColoringSettingsErrorable {\n    __typename\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        active\n        eventCategory\n        googleColorKey\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  calculateSmartHoldsErrorable(week: $week) {\n    __typename\n    ... on SmartHoldCalculationResult {\n      smartHolds {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n        }\n        endTime {\n          dateOrDateTime\n        }\n      }\n      events {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n        }\n        endTime {\n          dateOrDateTime\n        }\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingColorCodingStep_user on User {\n  id\n  emails\n  servicesFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment OnboardingFlexMeetingStepRenderer_org_3k5A6X on Org {\n  id\n  experiments\n  primaryOrgCalendar\n  ...OnboardingAutopilotEvent_org\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      suggestedOrganized {\n        ...OnboardingAutopilotEvent_event\n        calendarIds\n        title\n        annotatedEvent {\n          externalEventId\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        recurringEventId\n        recurrenceRules {\n          interval {\n            interval\n            freqType\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n          orgTags {\n            tag\n            state {\n              active\n              value\n              subjectType\n              subjectValue\n              lastModified\n            }\n          }\n        }\n        createdMillis\n        eventKey {\n          externalEventId\n          id\n        }\n        organizer {\n          urnValue\n        }\n        attendees {\n          urnValue\n        }\n        startTime {\n          millis\n        }\n        endTime {\n          millis\n        }\n        suggestedAutopilotSettingsResponseV3 {\n          __typename\n          ... on SuggestedAutopilotSettingsResponseV3 {\n            intersectionOfAttendeesMeetingHours {\n              minSlot {\n                dayOffset\n                timeSlot\n              }\n              maxSlot {\n                dayOffset\n                timeSlot\n              }\n            }\n            calendarIdToMeetingHours {\n              calendarId\n              dayOffsetTimeSlotRanges {\n                minSlot {\n                  dayOffset\n                  timeSlot\n                }\n                maxSlot {\n                  dayOffset\n                  timeSlot\n                }\n              }\n            }\n            suggestedAutopilotSettings {\n              isRoomFlexible\n              movementType\n              allowedEndTime {\n                dayOffset\n                timeSlot\n              }\n              allowedStartTime {\n                dayOffset\n                timeSlot\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n        moveRangeInLocalTimeV3 {\n          __typename\n          ... on MoveRangeInLocalTimeV3 {\n            allowedStartTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n            allowedEndTimeInclusive {\n              dayOffset\n              timeSlot\n            }\n          }\n          ... on GraphEntityError {\n            message\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment OnboardingFlexMeetingStepRenderer_user on User {\n  id\n  emails\n}\n\nfragment OnboardingFocusTimeSyncAndLunchStep_org on Org {\n  ...SmartHoldSync_org\n  id\n  primaryOrgCalendar\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncEnabled\n      focusTimeExternalTransparency\n      focusTimeIdealMinutesPerWeek\n      focusTimeSyncAll\n      focusTimeRemindersEnabled\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  eventColoringSettingsErrorable {\n    __typename\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        active\n        eventCategory\n        googleColorKey\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userMeetingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalWithinDayOptions {\n              minTimeSlot\n              maxTimeSlot\n              minimumDuration\n              idealDuration\n            }\n          }\n        }\n      }\n    }\n  }\n  calculateSmartHoldsErrorable(week: $week) {\n    __typename\n    ... on SmartHoldCalculationResult {\n      smartHolds {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n      events {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingFocusTimeSyncAndLunchStep_user on User {\n  id\n  emails\n}\n\nfragment OnboardingFocusTimeSyncStep_org on Org {\n  ...SmartHoldSync_org\n  id\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncEnabled\n      focusTimeSyncAll\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment OnboardingIntroduceAutopilotStep_org on Org {\n  experiments\n  optimisticSavingsForCurrentUserNextWeekErrorable {\n    __typename\n    ... on OptimisticSavings {\n      couldCalculate\n      savingMinutes\n    }\n  }\n}\n\nfragment OnboardingIntroduceFocusTimeStep_org_2XYUdJ on Org {\n  primaryOrgCalendar\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  calculateSmartHoldsErrorable(week: $week) {\n    __typename\n    ... on SmartHoldCalculationResult {\n      smartHolds {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n      events {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingIntroduceFocusTimeStep_user on User {\n  id\n  emails\n}\n\nfragment OnboardingInviteStep_org on Org {\n  ...OnboardingOrgInvite_org\n  id\n  experiments\n}\n\nfragment OnboardingInviteStep_viewer on Viewer {\n  ...OnboardingOrgInvite_viewer\n}\n\nfragment OnboardingLinksStep_org on Org {\n  id\n  experiments\n}\n\nfragment OnboardingLunchStep_org on Org {\n  id\n  userMeetingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalWithinDayOptions {\n              minTimeSlot\n              maxTimeSlot\n              minimumDuration\n              idealDuration\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingMeetingHoursStep_org on Org {\n  userMeetingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingNUX_viewer_WUKqv on Viewer {\n  ...WebAppNavAvatarMenu_viewer\n  ...OnboardingInviteStep_viewer\n  ...OnboardingTeamJoinCreateStep_viewer_2rslMm\n  outerTeamQueryResultErrorable: teamQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeMyTeams: false) {\n    __typename\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamId\n        id\n      }\n    }\n  }\n  user {\n    ...OnboardingChromeIntro_user\n    ...OnboardingFocusTimeSyncAndLunchStep_user\n    ...OnboardingIntroduceFocusTimeStep_user\n    ...OnboardingScheduleTestEventStepRenderer_user\n    ...OnboardingAutopilotStepRenderer_user\n    ...OnboardingColorCodingStep_user\n    ...OnboardingPrivateCalendarSyncStep_user\n    ...OnboardingSummaryStep_user\n    ...OnboardingFlexMeetingStepRenderer_user\n    createdTime\n    dataSources(first: 1000000) {\n      edges {\n        node {\n          id\n          state\n          type\n          name\n        }\n      }\n    }\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          ...FastCrawlErrorCard_org\n          ...OnboardingChromeIntro_org\n          ...OnboardingSurveyStep_org\n          ...IndividualJtbdSurveyStep_org\n          ...OnboardingTeamJoinCreateStep_org\n          ...OnboardingWorkingHoursStep_org\n          ...OnboardingMeetingHoursStep_org\n          ...OnboardingLunchStep_org\n          ...OnboardingFocusTimeSyncAndLunchStep_org\n          ...OnboardingIntroduceAutopilotStep_org\n          ...OnboardingLinksStep_org\n          ...OnboardingFocusTimeSyncStep_org\n          ...OnboardingPrivateCalendarSyncStep_org\n          ...OnboardingTravelTimeStep_org\n          ...OnboardingSlackStep_org\n          ...OnboardingSummaryStep_org\n          ...OnboardingIntroduceFocusTimeStep_org_2XYUdJ\n          ...OnboardingAutopilotStepRenderer_org_3k5A6X\n          ...OnboardingInviteStep_org\n          ...OnboardingColorCodingStep_org_2XYUdJ\n          ...OnboardingScheduleTestEventStepRenderer_org_2XYUdJ\n          ...OnboardingFlexMeetingStepRenderer_org_3k5A6X\n          id\n          primaryOrgCalendar\n          experiments\n          crawlTest\n          userTeams {\n            __typename\n            ... on TeamList {\n              list {\n                teamId\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment OnboardingOrgInvite_org on Org {\n  id\n  ...InviteCard_org\n  ...CopyPersonalInviteLinkBtn_org\n  experiments\n  personCorpusErrorable {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on PersonList {\n      list {\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n        id\n      }\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        id\n        targetCalendarId\n        targetProfile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        resolution\n        numberOfSharedMeetings\n        numberOfOrganizedMeetings\n        inviteReason\n        totalScore\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        id\n        targetCalendarId\n        lastSentTime\n        targetProfile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingOrgInvite_viewer on Viewer {\n  user {\n    ...CopyPersonalInviteLinkBtn_user\n    id\n  }\n  personQueryResultErrorable(query: \"\", orgRelayId: \"\") {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on PersonQueryResult {\n      query\n      persons {\n        id\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n      }\n    }\n  }\n}\n\nfragment OnboardingPrivateCalendarSyncStep_org on Org {\n  id\n  domains\n  ...DataSource_org\n  ...DataSourceCreate_org\n}\n\nfragment OnboardingPrivateCalendarSyncStep_user on User {\n  id\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n\nfragment OnboardingScheduleTestEventStepRenderer_org_2XYUdJ on Org {\n  id\n  primaryOrgCalendar\n  experiments\n  crawlTest\n  primaryOrgEmail\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  calculateSmartHoldsErrorable(week: $week) {\n    __typename\n    ... on SmartHoldCalculationResult {\n      events {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingScheduleTestEventStepRenderer_user on User {\n  id\n  emails\n}\n\nfragment OnboardingSlackStep_org on Org {\n  id\n  experiments\n  slackAccountsErrorable {\n    __typename\n    ... on SlackAccountList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        teamDisplayName\n        needsUpdate\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  slackSettingsErrorable {\n    __typename\n    ... on SlackSettingsList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        calendarStatus {\n          calendarStatusEnabled\n          includeMeetingCategory\n          includeMeetingTitle\n        }\n        dailyDigestSettings {\n          enabled\n          timeSlot\n        }\n        dndSettings {\n          focusTime\n          meeting\n        }\n        notificationSettings {\n          defragSummary\n        }\n        calendarStatusEnabled\n        includeMeetingCategory\n        includeMeetingTitle\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OnboardingSummaryStep_org on Org {\n  id\n  primaryOrgCalendar\n  domains\n  experiments\n  eventColoringSettingsErrorable {\n    __typename\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        active\n        eventCategory\n        googleColorKey\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        teamId\n        id\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n        }\n      }\n    }\n  }\n  slackAccountsErrorable {\n    __typename\n    ... on SlackAccountList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        teamDisplayName\n        needsUpdate\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  autopilotEventsResponse(timeZone: $timeZone) {\n    __typename\n    ... on AutopilotEventsResponse {\n      enabledOrganized {\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n      }\n      enabledAttending {\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n      }\n      suggestedOrganized {\n        annotatedEvent {\n          orgTags {\n            tag\n            state {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          userTags {\n            tag\n            states {\n              active\n              subjectType\n              subjectValue\n            }\n          }\n          id\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment OnboardingSummaryStep_user on User {\n  id\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n\nfragment OnboardingSurveyStep_org on Org {\n  id\n  primaryOrgCalendar\n  userSurveyResponseWrapperErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on UserSurveyResponseWrapper {\n      id\n      userSurveyResponses {\n        questionType\n        responseType\n        questionText\n        responseText\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment OnboardingTeamJoinCreateStep_org on Org {\n  ...TeamJoinCreate_org\n  ...AvatarRowNew_org\n  id\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        invitedMembers {\n          addedBy\n          person {\n            ...AvatarPerson_orgPerson\n            primaryCalendarId\n            userId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n        teamMembers {\n          addedBy\n          person {\n            ...AvatarPerson_orgPerson\n            primaryCalendarId\n            userId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingTeamJoinCreateStep_viewer_2rslMm on Viewer {\n  ...TeamJoinCreate_viewer_2rslMm\n  user {\n    id\n  }\n  id\n}\n\nfragment OnboardingTravelTimeStep_org on Org {\n  ...WorkAddress_org\n  workAddressForUser {\n    __typename\n    ... on Address {\n      rawAddress\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  id\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalWithinDayOptions {\n              minTimeSlot\n              maxTimeSlot\n              minimumDuration\n              idealDuration\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingWorkingHoursStep_org on Org {\n  experiments\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      ...DraggableWorkingHours_workingHours\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userMeetingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      ...DraggableWorkingHours_workingHours\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n}\n\nfragment SmartHoldSync_org on Org {\n  id\n  primaryOrgCalendar\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncEnabled\n      lunchSyncEnabled\n      travelTimeSyncEnabled\n      focusTimeExternalTransparency\n      focusTimeIdealMinutesPerWeek\n      focusTimeSyncAll\n      focusTimeRemindersEnabled\n      lunchRemindersEnabled\n      travelTimeRemindersEnabled\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  focusTimeStats {\n    __typename\n    ... on FocusTimeStats {\n      minutesPerWeek\n    }\n  }\n}\n\nfragment TeamJoinCreate_org on Org {\n  ...AvatarRowNew_org\n  ...TeamSettingsSearch_org\n  ...TeamSearchInputRenderer_org\n  id\n  primaryOrgCalendar\n  orgPersonForUserErrorable {\n    __typename\n    ... on OrgPerson {\n      personId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        teamMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n        invitedMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  suggestedTeams {\n    __typename\n    ... on SuggestedTeamList {\n      list {\n        team {\n          id\n          teamId\n          teamName\n          createdBy {\n            value\n            id\n          }\n          teamMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          invitedMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n        }\n        reasons {\n          type\n          value\n        }\n        score\n      }\n    }\n  }\n}\n\nfragment TeamJoinCreate_viewer_2rslMm on Viewer {\n  ...TeamSettingsSearch_viewer_YNSM7\n  user {\n    id\n  }\n  id\n  teamQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeMyTeams: true) {\n    __typename\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamName\n        teamId\n        teamRoleAndPersonIds {\n          role\n          personId\n        }\n        id\n      }\n      teamMembers {\n        role\n        person {\n          ...AvatarPerson_orgPerson\n          personId\n          primaryCalendarId\n          isYou\n          profile {\n            givenName\n            familyName\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSearchInputRenderer_org on Org {\n  id\n}\n\nfragment TeamSettingsSearch_org on Org {\n  ...TeamSettingsTeammate_org\n  id\n  primaryOrgCalendar\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        calendarIds\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsSearch_viewer_YNSM7 on Viewer {\n  orgPersonQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on OrgPersonQueryResult {\n      query\n      persons {\n        ...AvatarPerson_orgPerson\n        userId\n        personId\n        primaryCalendarId\n        calendarAliases\n        redirectPersonId\n        isYou\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsTeammate_org on Org {\n  ...AvatarPerson_org\n  id\n  primaryOrgEmail\n}\n\nfragment WebAppNavAvatarMenu_viewer on Viewer {\n  id\n  user {\n    givenName\n    familyName\n    externalImageUrl\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n      }\n    }\n    dataSources(first: 1000000) {\n      edges {\n        node {\n          id\n          status\n          name\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          primaryOrgCalendar\n          domains\n          slackAccountsErrorable {\n            __typename\n            ... on SlackAccountList {\n              list {\n                id\n                slackTeamId\n                slackUserId\n                teamDisplayName\n              }\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          eventColoringSettingsErrorable {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on EventColoringSettings {\n              eventCategoryColorings {\n                googleColorKey\n                eventCategory\n                active\n                isUserSet\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userPerson {\n            __typename\n            ... on Person {\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment WorkAddress_org on Org {\n  id\n  workAddressForUser {\n    __typename\n    ... on Address {\n      rawAddress\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a120df0db15b306fa01dbd6f83a5388b';
export default node;
